import { CustomAction } from "..";
import { AUTH_ACTION_TYPES } from "../actions-types";
import { AuthState } from "../../types/auth";

export const defaultState: AuthState = {
  type: null,
  isLoggedIn: false,
  isLoading: false,
  sessionToken: "",
  emailBanDuration: "",
};

export const authReducer = (
  state = defaultState,
  action: CustomAction
): AuthState => {
  switch (action.type) {
    case AUTH_ACTION_TYPES.SET_AUTH_TYPE:
      return {
        ...state,
        type: action.data,
      };
    case AUTH_ACTION_TYPES.SET_AUTH_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: action.data,
      };
    case AUTH_ACTION_TYPES.SET_AUTH_LOADING:
      return {
        ...state,
        isLoading: action.data,
      };
    case AUTH_ACTION_TYPES.SET_AUTH_SESSION_TOKEN:
      return {
        ...state,
        sessionToken: action.data,
      };
    case AUTH_ACTION_TYPES.SET_AUTH_EMAIL_BAN_DURATION:
      return {
        ...state,
        emailBanDuration: action.data,
      };
    case AUTH_ACTION_TYPES.RESET_AUTH:
      return defaultState;
    default:
      return state;
  }
};
